// @flow
import { UI_RESET_FACET_STATE } from './ui';

export const FACETS_LOADING = 'facets/LOADING';
export const FACETS_CANCEL_LOADING = 'facets/CANCEL_LOADING';
export const FACETS_SUCCESS = 'facets/SUCCESS';
export const FACETS_ERROR = 'facets/ERROR';

type State = {
  loading: boolean,
  counts: {},
  error: ''
};

type Action = {
  type: string,
  payload: {}
};

const initialState: State = {
  loading: false,
  counts: {},
  error: ''
};

function reducer(state: State = initialState, action: Action) {
  const { type, payload } = action;

  switch (type) {
    case FACETS_LOADING:
      return {
        ...state,
        loading: true
      };

    case FACETS_CANCEL_LOADING:
      return {
        ...state,
        loading: false
      };

    case FACETS_SUCCESS:
      return {
        ...state,
        ...payload,
        loading: false
      };

    case FACETS_ERROR:
      return {
        ...state,
        ...payload,
        loading: false
      };

    case UI_RESET_FACET_STATE:
      return {
        ...state,
        counts: {}
      };

    default:
      return state;
  }
}

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/facets.js